function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { _ as i } from "./index.es224.js";
import { i as s } from "./index.es568.js";
var t = i,
    b = s,
    e = "[object Symbol]";

function r(o) {
  return _typeof(o) == "symbol" || b(o) && t(o) == e;
}

var y = r;
export { y as i };